import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EMarkAsReadNotificationActionTypes, TMarkAsReadNotificationLoading } from './types';

export const markAsReadLoading: () => TMarkAsReadNotificationLoading =
  actionGenerator<EMarkAsReadNotificationActionTypes.Loading>(EMarkAsReadNotificationActionTypes.Loading);
